<template>
    <div>
        <i class="fa-light fa-warning fa-lg" />
        {{ text }}
    </div>
</template>

<script>
export default {
    props: {
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        text() {
            let string = this.$translate(
                'card_archived_text', 
                '{card} går inte längre att ansöka om'
            );
            return string.replace('{card}', this.document.data.title);
        }
    }
}
</script>
<style lang="scss" scoped>
div {
    width: 100%;
    @include flex(start, center);
    flex-wrap: nowrap;
    gap: 10px;
    @include spacing(padding, 4);
    @include border-radius(10px);
    border: 3px solid $red;
    color: $red;
    @include font-size(16px);
    font-weight: bold;
    @include spacing(margin, 12, bottom);
}
</style>